<template>
<div>
  <Top />
  <div class="maindiv pteacher-wrap  bg-gray">
    <Banner />
    <div class="teachers mt160 bgw htmldiv">
      <banner-title />
      <div class="detail">
        <div class="igs tcenter dinline-block vtop prelative">
          <img class="img pabsolute" :src="info.photo" />
        </div>
        <div class="dinline-block vtop rdiv">
          <div class="fs48 fbold mb10 mt40">{{info.name}}</div>
          <div class="tc13 sn mb5">教学经验：{{info.tea_age}}</div>
          <div class="fs16 tc9 lh20 mt40" v-html="info.intro">
          </div>
        </div>
      </div>
<!--      <div class="tplist pb20">-->
<!--        <div class="fs24 dbborder mb25">-->
<!--          <span class="dinline-block prelative st pb10 tc13 pl5 pr5">{{info.name}}的培训项目</span>-->
<!--        </div>-->
<!--        <TrainItem v-for="(item_,_index) in info.trainingProgram" v-if="_index < 3" :key="_index" :item="item_" :index="_index"/>-->
<!--      </div>-->
    </div>
    <div class="ht30"></div>
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from "../top";
import Banner from "../banner";
import Bottom from "../bottom";
import BannerTitle from "./ttitle";
import TrainItem from "../../index/train-item";

export default {
  name: "detail",
  data () {
    return {
      'info':{},
    }
  },
  components:{
    Top,
    Banner,
    Bottom,
    BannerTitle,
    TrainItem,
  },
  created() {
    var id = this.$route.query.id;
    var getParam = {};
    getParam['id'] = id;
    this.$request.get('teacher/detail',getParam,response => {
      if(response.status == 200){
        this.info = response.data.data;
      }
    },error => {
      console.log(error);
    })
  }
}
</script>

<style scoped>
.pteacher-wrap .detail{margin: 80px 0;min-height: 490px;}
.pteacher-wrap .detail .igs{width: 450px;}
.pteacher-wrap .detail img{margin: 0 auto;width: 60%;left: 0;right: 0;top: 0;}
.pteacher-wrap .detail .rdiv{width: 680px;}
.pteacher-wrap .detail .sn::before{content: '';display: inline-block;border: 7px solid transparent;border-left-color: #147ad8;}
.pteacher-wrap .tplist{padding-left: 55px;}
.pteacher-wrap .tplist .dbborder{margin-right: 50px;}
.pteacher-wrap .tplist .project{margin: 0 15px 35px 0;}
.pteacher-wrap .tplist .st{margin-bottom: -2px;border-bottom: 3px solid #147ad8;}
</style>



// WEBPACK FOOTER //
// src/components/train/teachers/detail.vue